export const preloadedStateStateKey = '__PRELOADED_STATE__';
